
/* styles */
require("!!vue-style-loader!css-loader!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0985c5a6&scoped=true!sass-loader!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NoteCard.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./NoteCard.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-0985c5a6!./../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./NoteCard.vue"),
  /* scopeId */
  "data-v-0985c5a6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/NoteCard.vue
// module id = 47
// module chunks = 0